// Lógica pura de "Leads sem atendimento" (LeadsSemAtendimentoPanel em EscalasComercialView.tsx)
// — extraída pra ficar testável fora do componente, seguindo o padrão de
// views/CRM/Kanban/kanbanWork.ts.

export const LIMIAR_AMBAR_MS = 2 * 3600 * 1000;
export const LIMIAR_VERMELHO_MS = 6 * 3600 * 1000;

export type NivelUrgencia = 'ok' | 'warn' | 'crit';

/** Severidade visual da linha, pelo tempo decorrido desde a atribuição. */
export const nivelUrgencia = (decorridoMs: number): NivelUrgencia =>
    decorridoMs >= LIMIAR_VERMELHO_MS ? 'crit' : decorridoMs >= LIMIAR_AMBAR_MS ? 'warn' : 'ok';

/** "Há quanto tempo" no formato compacto do painel (ex.: '45min', '2h', '2h 15min'). */
export const fmtDecorrido = (ms: number): string => {
    const totalMin = Math.max(0, Math.round(ms / 60000));
    const horas = Math.floor(totalMin / 60);
    const min = totalMin % 60;
    if (horas === 0) return `${min}min`;
    return `${horas}h${min > 0 ? ` ${min}min` : ''}`;
};
